import React from 'react';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Epi from 'Interface/Epis';
import { useRemoverEpiMutation } from 'View/Service/Default/Epis';

interface Props {
  dados: Epi;
  acoes?: boolean;
}

const Lista = ({ dados, acoes = true }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerEpi] = useRemoverEpiMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerEpi({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div
      key={dados.nome}
      className="d-flex border-bottom align-items-center py-2 px-3"
    >
      <div className="fs-4">
        <Link to={`/epis/editar/${dados.id}`} className="text-decoration-none">
          {dados.nome}
        </Link>
        <span className="text-muted fs-6 d-block">
          (CA: {dados.certificado_de_aprovacao})
        </span>
      </div>
      <div className="ms-5 fs-5 flex-grow-1 text-end">
        {acoes && (
          <Botao
            icone="trash"
            tema="danger"
            className="ms-5"
            confirmacao="Você tem certeza que deseja remover esse EPI? Essa ação é irreversivel."
            onClick={remover}
          />
        )}
      </div>
    </div>
  );
};

export default Lista;
